export function submitEventToValues(event) {
  event.preventDefault();
  var $form = $(event.target).closest('form');
  var $inputs = $form.find('input');
  var $selects = $form.find('select');
  var values = {};
  $inputs.each(function (index, input) {
    var $input = $(input);
    var name = $input.attr('name');
    var value = $input.val();
    values[name] = value;
  });
  $selects.each(function (index, select) {
    var name = $(select).attr('name');
    var selectedOption = $("select[name=".concat(name, "] option:selected"));
    var selectedOptionVal = selectedOption.val();
    values[name] = selectedOptionVal;
  });
  return values;
}